import { NgModule, Pipe } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormatDateTimePipe } from './format-date-time/format-date-time.pipe';
import { FormatJsonObjPipe } from './format-json-obj/format-json-obj.pipe';
import { DisplayDetailedAlertPipe } from './display-detailed-alert/display-detailed-alert.pipe';
import { ElementInArrayPipe } from './element-in-array/element-in-array.pipe';
import { ContractorEstimatedPricePipe } from './contractor-estimated-price/contractor-estimated-price.pipe';
import { KeysPipe } from './keys/keys.pipe';
import { ByteFormatterPipe } from './byte-formatter/byte-formatter.pipe';
import { DistanceConverterPipe } from './distance-converter/distance-converter.pipe';
import { ApnFormatterPipe } from './apn-formatter/apn-formatter.pipe';
import { FormatUsagePipe } from './format-usage/format-usage.pipe';
import { SpaceBetweenUppercasePipe } from './space-between-uppercase/space-between-uppercase.pipe';
import { TimeAgoPipe } from './time-ago/time-ago.pipe';

@NgModule({
  providers: [FormatDateTimePipe],
  declarations: [
    FormatDateTimePipe,
    FormatJsonObjPipe,
    DisplayDetailedAlertPipe,
    ElementInArrayPipe,
    ContractorEstimatedPricePipe,
    KeysPipe,
    ByteFormatterPipe,
    DistanceConverterPipe,
    ApnFormatterPipe,
    FormatUsagePipe,
    SpaceBetweenUppercasePipe,
    TimeAgoPipe,
  ],
  imports: [CommonModule],
  exports: [
    FormatDateTimePipe,
    FormatJsonObjPipe,
    DisplayDetailedAlertPipe,
    ElementInArrayPipe,
    ContractorEstimatedPricePipe,
    KeysPipe,
    ByteFormatterPipe,
    DistanceConverterPipe,
    ApnFormatterPipe,
    FormatUsagePipe,
    SpaceBetweenUppercasePipe,
    TimeAgoPipe,
  ],
})
export class PipesModule {}
